export default __webpack_public_path__ + "static/pomodoro-timer-991cbc38d097d5c95082f49891066407.png";